import React from 'react'

const OmronDevice = () => {
  return (
    <div>OmronDevice</div>
  )
}

export default OmronDevice